import { Fragment } from "react";
import Home from "./Pages/Home";

function App() {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
}

export default App;
